import React, { useEffect, useState } from "react";
import ContactService from "../../services/ContactService";


const Messages = () => {
  const [messages, setMessages] = useState([]);

  const getMessages = async () => {
    try {
      var response = await ContactService.getContactSubmissions();
      if (response) {
        setMessages(response);
      }
    } catch (error) {}
  };


  useEffect(() => {
    getMessages();
  }, []);

  return (
    <div className="container">
      <div className="overview d-flex align-items-center justify-content-between">
        <div className="title">
        <ion-icon name="mail-outline"></ion-icon>
        <span className="text">Messages</span>
        </div>
      </div>

      <div className="data-table activityTable">
        <div className="tableStyle">
          <table>
            <thead>
              <tr>
                <th className="admin-th">Date</th>
                <th className="admin-th">Name</th>
                <th className="admin-th">Phone</th>
                <th className="admin-th">City</th>
                <th className="admin-th">Country</th>
                <th className="admin-th">Gender</th>
                <th className="admin-th">Message</th>
              </tr>
            </thead>
            <tbody>
              {messages?.map((message, index) => (
                <tr>
                  <td className="admin-td">{message.createdAt}</td>
                  <td className="admin-td">{message.name}</td>
                  <td className="admin-th">{message.phone}</td>
                  <td className="admin-td">{message.city}</td>
                  <td className="admin-td">{message.country}</td>
                  <td className="admin-td">{message.gender}</td>
                  <td className="admin-td">{message.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Messages;
